module.exports = __webpack_public_path__ + "static/img/9.c5aca42.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/9.png
// module id = 2Jsi
// module chunks = 0